import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {PatientPhr} from '../models/patient-phr.model';

@Injectable()
export class PatientPhrAdapter implements IAdapter<PatientPhr> {
  adaptToModel(resp: PatientPhr): PatientPhr {
    const patientPhr: PatientPhr = {...resp};
    if (resp.toDate && resp.fromDate) {
      patientPhr.toDate = new Date(resp.toDate).toLocaleDateString();
      patientPhr.fromDate = new Date(resp.fromDate).toLocaleDateString();
    }
    if (patientPhr.url) {
      patientPhr.extension = patientPhr.url.split('.').pop().split('?')[0];
    }

    return patientPhr;
  }
  // sonarignore:start
  adaptFromModel(data: PatientPhr): any {
    return data;
  }
  // sonarignore:end
}
